import { Link } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { articles } from "@/mocks/articles";
import { categoryList } from "@/mocks/categories";

export default function ArticleListPage() {
  const articleListSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "文章资讯 - 蘑菇视频",
    description: "蘑菇视频最新文章资讯，包括APP使用教程、产品更新动态、视频行业资讯等内容。",
    url: "https://www.moguvideo.com/articles",
  };

  return (
    <>
      <SEOHead
        title="文章资讯 - 蘑菇视频使用教程与产品动态"
        description="蘑菇视频文章资讯中心：APP安装教程、使用技巧、产品更新动态、视频行业资讯。助你快速上手蘑菇视频播放器。"
        keywords="蘑菇视频教程,APP安装,视频播放器使用,产品更新,视频资讯"
        canonicalUrl="https://www.moguvideo.com/articles"
        schemaData={articleListSchema}
      />
      <Navbar />

      <main className="pt-16">
        <Breadcrumb items={[{ label: "文章资讯" }]} />

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-10">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                文章资讯
              </h1>
              <p className="text-sm text-foreground-600">使用教程、产品动态、行业资讯 — 助你更好地使用蘑菇视频</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors cursor-pointer group"
                >
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={article.cover}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2.5 flex-wrap">
                      <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                      <span className="text-xs text-foreground-500">{article.readTime}</span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                    <div className="flex items-center gap-1.5 mt-3 flex-wrap">
                      {article.tags.map((tag) => (
                        <span key={tag} className="text-xs px-2 py-0.5 rounded-md bg-background-50 text-foreground-500 whitespace-nowrap">
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Sidebar-like category section */}
            <div className="mt-16">
              <h3 className="text-lg font-semibold text-foreground-950 mb-5" style={{ fontFamily: "var(--font-heading)" }}>
                探索视频分类
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
                {categoryList.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    className="flex items-center gap-2 px-4 py-3 rounded-xl bg-background-100 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    <i className={`${cat.icon} text-base`}></i>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}